<div class="kl-invoice-data-card">
    <vl-info-tile tag-name="div" :title="organisationInvoiceSetting.company">
        <template v-slot:headerextension v-if="!readOnly">
            <vl-action-group>
                <vl-button type="button" icon="pencil" @click="updateInvoiceSetting" mod-icon mod-secondary hidden-text="Bewerk facturatiegegevens" />
            </vl-action-group>
        </template>
        <vl-form-grid mod-stacked mod-v-center>
            <vl-column width="12">
                <p>
                    <ippro-icon-text icon="mail">{{ organisationInvoiceSetting.email }}</ippro-icon-text>
                </p>
                <p v-if="organisationInvoiceSetting.attention">
                    <span v-vl-text.light>Ter attentie van:</span> {{ organisationInvoiceSetting.attention }}
                </p>
                <p v-if="organisationInvoiceSetting.reference">
                    <span v-vl-text.light>Eigen referentie:</span> {{ organisationInvoiceSetting.reference }}
                </p>
            </vl-column>
            <vl-column width="12" v-if="hasContactInfo">
                <vl-title tag-style="h6">Contactpersoon i.v.m. facturatie</vl-title>
                <p v-if="organisationInvoiceSetting.invoiceContactName">
                    {{ organisationInvoiceSetting.invoiceContactName }}
                </p>
                <p v-if="organisationInvoiceSetting.invoiceContactEmail">
                    <vl-link :href="`mailto:${organisationInvoiceSetting.invoiceContactEmail}`" icon="mail" mod-icon-before>{{ organisationInvoiceSetting.invoiceContactEmail }}</vl-link>
                </p>
                <p v-if="organisationInvoiceSetting.invoiceContactPhoneNumber">
                    <ippro-icon-text icon="phone">{{ organisationInvoiceSetting.invoiceContactPhoneNumber }}</ippro-icon-text>
                </p>
            </vl-column>
        </vl-form-grid>
    </vl-info-tile>
</div>
